import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";

const Dashboardtable = ({ data }) => {
  const [list, setList] = useState([]);

  useEffect(() => {
    if (data.length > 0) {
      setList(
        data?.map((items, i) => ({
          sno: i + 1,
          filename: items?.article?.forEach((element) => {
            return element.article_title;
          }),
          checkname: items.title,
        }))
      );
    }
  }, [data]);

  console.log(list);

  const columns = [
    {
      name: "S.NO",
      selector: (row) => row.sNo,
      sortable: true,
      width: "100px",
    },
    { name: "File Name", selector: (row) => row.fileName, sortable: true },
    { name: "Available", selector: (row) => row.isAvailable, sortable: true },
  ];

  const tableData =
    data.length > 0
      ? data.map((section, sectionIndex) => ({
          title: section?.title,
          rows: section?.article?.map((item, index) => ({
            sNo: index + 1,
            fileName: item.article_title,
            isAvailable:
              section.c_id === 9
                ? item.count === 1
                  ? "EN"
                  : "Non EN"
                : item.count === 1
                ? "True"
                : "False",
          })),
        }))
      : [];

  return (
    <div className="w-full grid grid-cols-3 gap-5">
      {tableData?.map((section, index) => (
        <div key={index} className="flex flex-col gap-5">
          <h2 className="text-20">{section.title}</h2>
          <DataTable
            columns={columns}
            data={section.rows}
            customStyles={{
              rows: {
                style: {
                  fontSize: "16px",
                },
              },
            }}
            pagination
            highlightOnHover
            conditionalRowStyles={[
              {
                when: (row) =>
                  row.isAvailable === "True" || row.isAvailable === "EN",
                style: {
                  backgroundColor: "rgba(0, 255, 0, 0.2)", // Light green
                  color: "black",
                },
              },
              {
                when: (row) =>
                  row.isAvailable === "False" || row.isAvailable === "Non EN",
                style: {
                  backgroundColor: "rgba(255, 0, 0, 0.2)", // Light red
                  color: "black",
                },
              },
            ]}
          />
        </div>
      ))}
    </div>
  );
};

export default Dashboardtable;
